import "@/helpers/turbo"

import { initErrorSearch } from "@/components/elm_search"
import { setupSearchBar } from "@/components/search_bar"

const NEW_SEARCH_BAR = document.body.getAttribute("data-new-search-bar") === "true"

if (NEW_SEARCH_BAR) {
  setupSearchBar()
} else {
  initErrorSearch()
}
